<template>
	<v-card 
		class="text-center mx-auto"
		max-width="400"
		width="100%"
		flat
	>
		<v-card-item>
			<v-card-title :class="titleClass">
				{{ title }}
			</v-card-title>
			<v-card-subtitle :class="subtitleClass">
				{{ subtitle }}
			</v-card-subtitle>
		</v-card-item>

		<v-card-text>
			{{ text }}
		</v-card-text>
		
		<v-card-text>
			<v-form ref="form">
				<!-- <z-photo
					v-model="value"
				></z-photo> -->
			</v-form>
		</v-card-text>
	</v-card>
</template>

<script>
import mixin from './mixin/main'
//import zPhoto from '@/components/banners/Photo3'

export default {
	mixins: [mixin],
	components: {
		//zPhoto
	},

	props: {
		modelValue:			{ type: Array, default: () => [] },
	},
}
</script>
